module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"panBox","short_name":"panBox","start_url":"/","theme_color":"#00AAAA","background_color":"#EEEEEE","icon":"src/images/panbox-favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ac02d72b22e4385ee794f60d514f4b8f"},
    },{
      plugin: require('../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"typekit":{"id":"https://use.typekit.net/lej5wua.css"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-NJQJ7MFFMB"],"pluginConfig":{"respectDNT":true,"exclude":["/mina-sidor/**"]}},
    },{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"988274975434405"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
